import React from "react";
import Button from "../../components/ui/Button";

const BiospecimenHero = () => {
  return (
    <section className="flex flex-col items-center justify-center px-6 py-8 md:py-16 text-center bg-white">
      <div className="max-w-[1800px] mx-auto">
        {/* Main Heading */}
        <h1 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-[#183076] leading-tight mb-6">
          Custom Biospecimen Procurement to <br className="hidden md:block" />{" "}
          Your Exact Protocol
        </h1>

        {/* Description Text */}
        <p className="text-[16px] md:text-[18px] xl:text-[24px] max-w-[1600px] mx-auto leading-relaxed mb-10">
          When existing inventory doesn't meet your needs, we design and execute
          custom prospective collection studies. From rare patient populations
          to complex matched sets, we bring your specimen requirements to life
          with precision and speed.
        </p>

        {/* Buttons Container */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            className="border-2 border-[#183076] text-[#183076] px-8 py-3 rounded-full font-bold hover:bg-[#183076] hover:text-white transition 2xl:text-[24px]"
            text="Book Now"
            to="/rfq"
          />
          <button className="bg-white text-blue-900 px-8 py-3 rounded-full font-bold  border-2 transition shadow-xl 2xl:text-[24px hover:bg-[#183076] hover:text-[#FFFFFF] transition 2xl:text-[24px]">
            Explore Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default BiospecimenHero;
